import { ofArray, singleton } from "../fable_modules/fable-library-js.4.28.0/List.js";

export const Account_changePassword = "account.change_password";

export const Account_confirmPassword = "account.confirm_password";

export const Account_connectedAccounts = "account.connected_accounts";

export const Account_currentPassword = "account.current_password";

export const Account_dangerZone = "account.danger_zone";

export const Account_deleteAccount = "account.delete_account";

export const Account_deleteWarning = "account.delete_warning";

export const Account_deleting = "account.deleting";

export const Account_email = "account.email";

export const Account_emailReadOnly = "account.email_read_only";

export const Account_name = "account.name";

export const Account_newPassword = "account.new_password";

export const Account_noConnectedAccounts = "account.no_connected_accounts";

export const Account_password = "account.password";

export const Account_passwordChanged = "account.password_changed";

export const Account_passwordSet = "account.password_set";

export const Account_profile = "account.profile";

export const Account_profileUpdated = "account.profile_updated";

export const Account_saveProfile = "account.save_profile";

export const Account_saving = "account.saving";

export const Account_setPassword = "account.set_password";

export const Account_setPasswordHint = "account.set_password_hint";

export const Account_title = "account.title";

export const Account_typeDelete = "account.type_delete";

export function Api_arrangeInterrupted(v0) {
    return ["api.arrange_interrupted", singleton(v0)];
}

export const Api_arrangeNoSolution = "api.arrange_no_solution";

export function Api_arrangeTimedOut(v0, v1) {
    return ["api.arrange_timed_out", ofArray([v0, v1])];
}

export function Api_arrangeTimedOutExcluded(v0, v1, v2) {
    return ["api.arrange_timed_out_excluded", ofArray([v0, v1, v2])];
}

export const Api_arrangerError = "api.arranger_error";

export function Api_arrangerStopped(v0) {
    return ["api.arranger_stopped", singleton(v0)];
}

export const Api_arrangerTimeout = "api.arranger_timeout";

export const Api_csvHeaderRequired = "api.csv_header_required";

export function Api_csvMissingColumn(v0) {
    return ["api.csv_missing_column", singleton(v0)];
}

export function Api_csvParseError(v0) {
    return ["api.csv_parse_error", singleton(v0)];
}

export const Api_currentPasswordRequired = "api.current_password_required";

export const Api_emailAlreadyRegistered = "api.email_already_registered";

export const Api_nameRequired = "api.name_required";

export const Api_noGuestsToSeat = "api.no_guests_to_seat";

export const Api_noValidArrangement = "api.no_valid_arrangement";

export const Api_noValidArrangementOrtools = "api.no_valid_arrangement_ortools";

export function Api_notEnoughSeats(v0, v1) {
    return ["api.not_enough_seats", ofArray([v0, v1])];
}

export const Api_socialLogin = "api.social_login";

export function Api_tablesExcluded(v0) {
    return ["api.tables_excluded", singleton(v0)];
}

export const Api_wrongPassword = "api.wrong_password";

export const App_backToDashboard = "app.back_to_dashboard";

export const App_checkMark = "app.check_mark";

export const App_eventNotFound = "app.event_not_found";

export const App_goToDashboard = "app.go_to_dashboard";

export const App_loadingEvent = "app.loading_event";

export const App_notFound = "app.not_found";

export const App_pleaseLogin = "app.please_login";

export const Arrange_addNote = "arrange.add_note";

export function Arrange_arrangementN(v0) {
    return ["arrange.arrangement_n", singleton(v0)];
}

export const Arrange_cancel = "arrange.cancel";

export const Arrange_cancelling = "arrange.cancelling";

export const Arrange_emptySeatLabel = "arrange.empty_seat_label";

export const Arrange_generating = "arrange.generating";

export const Arrange_hardViolations = "arrange.hard_violations";

export const Arrange_hidePreview = "arrange.hide_preview";

export const Arrange_liked = "arrange.liked";

export const Arrange_noArrangements = "arrange.no_arrangements";

export const Arrange_optimal = "arrange.optimal";

export function Arrange_previewHeader(v0, v1) {
    return ["arrange.preview_header", ofArray([v0, v1])];
}

export const Arrange_ready = "arrange.ready";

export const Arrange_score = "arrange.score";

export const Arrange_seating = "arrange.seating";

export const Arrange_select = "arrange.select";

export const Arrange_selected = "arrange.selected";

export function Arrange_showDetails(v0) {
    return ["arrange.show_details", singleton(v0)];
}

export const Arrange_showPreview = "arrange.show_preview";

export function Arrange_showScoring(v0) {
    return ["arrange.show_scoring", singleton(v0)];
}

export const Arrange_softViolations = "arrange.soft_violations";

export const Arrange_stale = "arrange.stale";

export function Arrange_thankYou(v0) {
    return ["arrange.thank_you", singleton(v0)];
}

export const Arrange_thumbsDown = "arrange.thumbs_down";

export const Arrange_thumbsUp = "arrange.thumbs_up";

export const Arrange_timeoutLabel = "arrange.timeout_label";

export function Arrange_validationManyEmpty(v0, v1) {
    return ["arrange.validation_many_empty", ofArray([v0, v1])];
}

export const Arrange_validationNoGenders = "arrange.validation_no_genders";

export const Arrange_validationNoGuests = "arrange.validation_no_guests";

export const Arrange_validationNoRules = "arrange.validation_no_rules";

export const Arrange_validationNoTables = "arrange.validation_no_tables";

export function Arrange_validationNotEnoughSeats(v0, v1) {
    return ["arrange.validation_not_enough_seats", ofArray([v0, v1])];
}

export const Arrange_validationTitle = "arrange.validation_title";

export const Arrange_view = "arrange.view";

export const Auth_agreeToTermsLink = "auth.agree_to_terms_link";

export const Auth_agreeToTermsPrefix = "auth.agree_to_terms_prefix";

export const Auth_backToLogin = "auth.back_to_login";

export const Auth_confirmPassword = "auth.confirm_password";

export const Auth_confirmPasswordPlaceholder = "auth.confirm_password_placeholder";

export const Auth_debugLoginButton = "auth.debug_login_button";

export const Auth_debugModeBadge = "auth.debug_mode_badge";

export const Auth_debugTitle = "auth.debug_title";

export const Auth_email = "auth.email";

export const Auth_emailPlaceholder = "auth.email_placeholder";

export const Auth_forgotPassword = "auth.forgot_password";

export const Auth_forgotPasswordSuccess = "auth.forgot_password_success";

export const Auth_forgotPasswordTitle = "auth.forgot_password_title";

export const Auth_loginButton = "auth.login_button";

export const Auth_loginFailed = "auth.login_failed";

export const Auth_loginTitle = "auth.login_title";

export const Auth_name = "auth.name";

export const Auth_namePlaceholder = "auth.name_placeholder";

export const Auth_newPassword = "auth.new_password";

export const Auth_newPasswordPlaceholder = "auth.new_password_placeholder";

export const Auth_orContinueWith = "auth.or_continue_with";

export const Auth_password = "auth.password";

export const Auth_passwordPlaceholder = "auth.password_placeholder";

export const Auth_passwordsMismatch = "auth.passwords_mismatch";

export const Auth_registerButton = "auth.register_button";

export const Auth_registerSuccess = "auth.register_success";

export const Auth_registerTitle = "auth.register_title";

export const Auth_resetPassword = "auth.reset_password";

export const Auth_resetPasswordError = "auth.reset_password_error";

export const Auth_resetPasswordSuccess = "auth.reset_password_success";

export const Auth_selectUser = "auth.select_user";

export const Auth_sendResetLink = "auth.send_reset_link";

export const Auth_submitting = "auth.submitting";

export const Auth_switchToLogin = "auth.switch_to_login";

export const Auth_switchToRegister = "auth.switch_to_register";

export const Auth_turnstileFailed = "auth.turnstile_failed";

export const Common_actions = "common.actions";

export const Common_back = "common.back";

export const Common_cancel = "common.cancel";

export const Common_close = "common.close";

export const Common_confirm = "common.confirm";

export const Common_delete = "common.delete";

export const Common_edit = "common.edit";

export const Common_filter = "common.filter";

export const Common_loading = "common.loading";

export const Common_next = "common.next";

export const Common_no = "common.no";

export const Common_ok = "common.ok";

export const Common_required = "common.required";

export const Common_save = "common.save";

export const Common_search = "common.search";

export const Common_yes = "common.yes";

export const Contact_attachments = "contact.attachments";

export const Contact_attachmentsHint = "contact.attachments_hint";

export const Contact_description = "contact.description";

export const Contact_descriptionPlaceholder = "contact.description_placeholder";

export const Contact_email = "contact.email";

export const Contact_emailPlaceholder = "contact.email_placeholder";

export const Contact_errorFileTooLarge = "contact.error_file_too_large";

export const Contact_errorRequired = "contact.error_required";

export const Contact_errorSendFailed = "contact.error_send_failed";

export const Contact_errorTooManyFiles = "contact.error_too_many_files";

export const Contact_intro = "contact.intro";

export const Contact_sending = "contact.sending";

export const Contact_subject = "contact.subject";

export const Contact_subjectPlaceholder = "contact.subject_placeholder";

export const Contact_submit = "contact.submit";

export const Contact_success = "contact.success";

export const Contact_title = "contact.title";

export const Detail_back = "detail.back";

export const Detail_cancelSwap = "detail.cancel_swap";

export const Detail_capacity = "detail.capacity";

export function Detail_capacityLabel(v0) {
    return ["detail.capacity_label", singleton(v0)];
}

export function Detail_changesCount(v0) {
    return ["detail.changes_count", singleton(v0)];
}

export const Detail_done = "detail.done";

export const Detail_edit = "detail.edit";

export const Detail_editModeHint = "detail.edit_mode_hint";

export const Detail_emptySeat = "detail.empty_seat";

export const Detail_family = "detail.family";

export const Detail_gender = "detail.gender";

export function Detail_genderBalance(v0, v1) {
    return ["detail.gender_balance", ofArray([v0, v1])];
}

export const Detail_guestInfo = "detail.guest_info";

export const Detail_guests = "detail.guests";

export function Detail_guestsLabel(v0) {
    return ["detail.guests_label", singleton(v0)];
}

export const Detail_hardViolations = "detail.hard_violations";

export const Detail_list = "detail.list";

export const Detail_lockTitle = "detail.lock_title";

export function Detail_lockedCount(v0) {
    return ["detail.locked_count", singleton(v0)];
}

export const Detail_lockedHint = "detail.locked_hint";

export const Detail_name = "detail.name";

export const Detail_noArrangement = "detail.no_arrangement";

export const Detail_noSelection = "detail.no_selection";

export const Detail_notFound = "detail.not_found";

export const Detail_overview = "detail.overview";

export const Detail_partner = "detail.partner";

export const Detail_rearrange = "detail.rearrange";

export const Detail_rearrangeTitle = "detail.rearrange_title";

export const Detail_redo = "detail.redo";

export const Detail_reset = "detail.reset";

export const Detail_saveAsNew = "detail.save_as_new";

export const Detail_saveComingSoon = "detail.save_coming_soon";

export const Detail_score = "detail.score";

export const Detail_seat = "detail.seat";

export const Detail_seatedGuests = "detail.seated_guests";

export const Detail_seating = "detail.seating";

export const Detail_shape = "detail.shape";

export const Detail_softViolations = "detail.soft_violations";

export function Detail_swapHint(v0) {
    return ["detail.swap_hint", singleton(v0)];
}

export const Detail_table = "detail.table";

export const Detail_tableInfo = "detail.table_info";

export function Detail_tableLabel(v0) {
    return ["detail.table_label", singleton(v0)];
}

export const Detail_undo = "detail.undo";

export const Detail_unlockTitle = "detail.unlock_title";

export const Dietary_categoryAllergy = "dietary.category_allergy";

export const Dietary_categoryDiet = "dietary.category_diet";

export const Dietary_categoryMedical = "dietary.category_medical";

export const Dietary_categoryOther = "dietary.category_other";

export const Dietary_categoryReligious = "dietary.category_religious";

export const Dietary_dairyFree = "dietary.dairy_free";

export const Dietary_dairyFreeDesc = "dietary.dairy_free_desc";

export const Dietary_diabetic = "dietary.diabetic";

export const Dietary_diabeticDesc = "dietary.diabetic_desc";

export const Dietary_eggFree = "dietary.egg_free";

export const Dietary_eggFreeDesc = "dietary.egg_free_desc";

export const Dietary_glutenFree = "dietary.gluten_free";

export const Dietary_glutenFreeDesc = "dietary.gluten_free_desc";

export const Dietary_halal = "dietary.halal";

export const Dietary_halalDesc = "dietary.halal_desc";

export const Dietary_hinduVeg = "dietary.hindu_veg";

export const Dietary_hinduVegDesc = "dietary.hindu_veg_desc";

export const Dietary_kosher = "dietary.kosher";

export const Dietary_kosherDesc = "dietary.kosher_desc";

export const Dietary_lactoseFree = "dietary.lactose_free";

export const Dietary_lactoseFreeDesc = "dietary.lactose_free_desc";

export const Dietary_lowSodium = "dietary.low_sodium";

export const Dietary_lowSodiumDesc = "dietary.low_sodium_desc";

export const Dietary_noAlcohol = "dietary.no_alcohol";

export const Dietary_noAlcoholDesc = "dietary.no_alcohol_desc";

export const Dietary_noPork = "dietary.no_pork";

export const Dietary_noPorkDesc = "dietary.no_pork_desc";

export const Dietary_noRedMeat = "dietary.no_red_meat";

export const Dietary_noRedMeatDesc = "dietary.no_red_meat_desc";

export const Dietary_nutFree = "dietary.nut_free";

export const Dietary_nutFreeDesc = "dietary.nut_free_desc";

export const Dietary_pescatarian = "dietary.pescatarian";

export const Dietary_pescatarianDesc = "dietary.pescatarian_desc";

export const Dietary_shellfishFree = "dietary.shellfish_free";

export const Dietary_shellfishFreeDesc = "dietary.shellfish_free_desc";

export const Dietary_soyFree = "dietary.soy_free";

export const Dietary_soyFreeDesc = "dietary.soy_free_desc";

export const Dietary_vegan = "dietary.vegan";

export const Dietary_veganDesc = "dietary.vegan_desc";

export const Dietary_vegetarian = "dietary.vegetarian";

export const Dietary_vegetarianDesc = "dietary.vegetarian_desc";

export const Enum_Age_adult = "enum.age.adult";

export const Enum_Age_child = "enum.age.child";

export const Enum_Age_senior = "enum.age.senior";

export const Enum_Age_teen = "enum.age.teen";

export const Enum_Attendance_active = "enum.attendance.active";

export const Enum_Attendance_attending = "enum.attendance.attending";

export const Enum_Attendance_invited = "enum.attendance.invited";

export const Enum_Attendance_notAttending = "enum.attendance.notAttending";

export const Enum_Attendance_notInvited = "enum.attendance.notInvited";

export const Enum_Culture_American_desc = "enum.culture.american.desc";

export const Enum_Culture_British_desc = "enum.culture.british.desc";

export const Enum_Culture_Chinese_desc = "enum.culture.chinese.desc";

export const Enum_Culture_Custom_desc = "enum.culture.custom.desc";

export const Enum_Culture_French_desc = "enum.culture.french.desc";

export const Enum_Culture_International_desc = "enum.culture.international.desc";

export const Enum_Culture_Swedish_desc = "enum.culture.swedish.desc";

export const Enum_Culture_american = "enum.culture.american";

export const Enum_Culture_british = "enum.culture.british";

export const Enum_Culture_chinese = "enum.culture.chinese";

export const Enum_Culture_custom = "enum.culture.custom";

export const Enum_Culture_french = "enum.culture.french";

export const Enum_Culture_international = "enum.culture.international";

export const Enum_Culture_swedish = "enum.culture.swedish";

export const Enum_Emptyseat_consolidate = "enum.emptyseat.consolidate";

export const Enum_Emptyseat_off = "enum.emptyseat.off";

export const Enum_Emptyseat_reduce = "enum.emptyseat.reduce";

export const Enum_Emptyseat_spread = "enum.emptyseat.spread";

export const Enum_Eventtype_banquet = "enum.eventtype.banquet";

export const Enum_Eventtype_casual = "enum.eventtype.casual";

export const Enum_Eventtype_corporate = "enum.eventtype.corporate";

export const Enum_Eventtype_custom = "enum.eventtype.custom";

export const Enum_Eventtype_formaldinner = "enum.eventtype.formaldinner";

export const Enum_Eventtype_wedding = "enum.eventtype.wedding";

export const Enum_Gender_female = "enum.gender.female";

export const Enum_Gender_male = "enum.gender.male";

export const Enum_Gender_nonbinary = "enum.gender.nonbinary";

export const Enum_Gender_unspecified = "enum.gender.unspecified";

export const Enum_Pairtype_dating = "enum.pairtype.dating";

export const Enum_Pairtype_engaged = "enum.pairtype.engaged";

export const Enum_Pairtype_partner = "enum.pairtype.partner";

export const Enum_Pairtype_spouse = "enum.pairtype.spouse";

export const Enum_Ruletype_adjacent = "enum.ruletype.adjacent";

export const Enum_Ruletype_assignseat = "enum.ruletype.assignseat";

export const Enum_Ruletype_assigntable = "enum.ruletype.assigntable";

export const Enum_Ruletype_excludefromtable = "enum.ruletype.excludefromtable";

export const Enum_Ruletype_keepapart = "enum.ruletype.keepapart";

export const Enum_Ruletype_keeptogether = "enum.ruletype.keeptogether";

export const Enum_Ruletype_maxpertable = "enum.ruletype.maxpertable";

export const Enum_Ruletype_opposite = "enum.ruletype.opposite";

export const Enum_Seating_allsides = "enum.seating.allsides";

export const Enum_Seating_oneside = "enum.seating.oneside";

export const Enum_Seating_onesided = "enum.seating.onesided";

export const Enum_Shape_oval = "enum.shape.oval";

export const Enum_Shape_rectangular = "enum.shape.rectangular";

export const Enum_Shape_round = "enum.shape.round";

export const Enum_Shape_square = "enum.shape.square";

export const Error_forbidden = "error.forbidden";

export const Error_network = "error.network";

export const Error_notFound = "error.not_found";

export const Error_server = "error.server";

export const Error_unauthorized = "error.unauthorized";

export function Error_validation(v0) {
    return ["error.validation", singleton(v0)];
}

export const Error_versionConflict = "error.version_conflict";

export const Event_confirmDelete = "event.confirm_delete";

export const Event_confirmYes = "event.confirm_yes";

export const Event_createButton = "event.create_button";

export function Event_created(v0) {
    return ["event.created", singleton(v0)];
}

export const Event_creating = "event.creating";

export const Event_culture = "event.culture";

export const Event_date = "event.date";

export function Event_deleteConfirm(v0) {
    return ["event.delete_confirm", singleton(v0)];
}

export const Event_deleted = "event.deleted";

export function Event_guestsCount(v0) {
    return ["event.guests_count", singleton(v0)];
}

export const Event_name = "event.name";

export const Event_namePlaceholder = "event.name_placeholder";

export const Event_new = "event.new";

export const Event_noEvents = "event.no_events";

export const Event_pageTitle = "event.page_title";

export function Event_solutionsCount(v0) {
    return ["event.solutions_count", singleton(v0)];
}

export function Event_tablesCount(v0) {
    return ["event.tables_count", singleton(v0)];
}

export const Event_type = "event.type";

export const Event_updated = "event.updated";

export const Export_Layout_boldStatement = "export.layout.boldStatement";

export const Export_Layout_cleanModern = "export.layout.cleanModern";

export const Export_Layout_elegantSerif = "export.layout.elegantSerif";

export const Export_Layout_handwritten = "export.layout.handwritten";

export const Export_Layout_vintageClassic = "export.layout.vintageClassic";

export const Export_Theme_classicWarmth = "export.theme.classicWarmth";

export const Export_Theme_corporateNavy = "export.theme.corporateNavy";

export const Export_Theme_gardenBotanical = "export.theme.gardenBotanical";

export const Export_Theme_midnightFestive = "export.theme.midnightFestive";

export const Export_Theme_romanticBlush = "export.theme.romanticBlush";

export function Export_arrangementScore(v0) {
    return ["export.arrangement_score", singleton(v0)];
}

export function Export_arrangementStats(v0, v1) {
    return ["export.arrangement_stats", ofArray([v0, v1])];
}

export const Export_csv = "export.csv";

export const Export_csvDesc = "export.csv_desc";

export const Export_csvSection = "export.csv_section";

export const Export_csvTitle = "export.csv_title";

export const Export_download = "export.download";

export const Export_downloading = "export.downloading";

export const Export_floorPlan = "export.floor_plan";

export const Export_floorPlanDesc = "export.floor_plan_desc";

export const Export_fullLayout = "export.full_layout";

export const Export_fullLayoutDesc = "export.full_layout_desc";

export const Export_image = "export.image";

export const Export_layout = "export.layout";

export const Export_nameCards = "export.name_cards";

export const Export_nameCardsDesc = "export.name_cards_desc";

export const Export_noArrangement = "export.no_arrangement";

export const Export_pdfCards = "export.pdf_cards";

export const Export_pdfLayout = "export.pdf_layout";

export const Export_pdfSection = "export.pdf_section";

export const Export_pdfTables = "export.pdf_tables";

export const Export_preview = "export.preview";

export const Export_seatingDiagram = "export.seating_diagram";

export const Export_seatingDiagramDesc = "export.seating_diagram_desc";

export const Export_selectHint = "export.select_hint";

export const Export_tab = "export.tab";

export const Export_tableCards = "export.table_cards";

export const Export_tableCardsDesc = "export.table_cards_desc";

export const Export_theme = "export.theme";

export const Export_title = "export.title";

export const Floor_autoLayout = "floor.auto_layout";

export const Floor_gridSnap = "floor.grid_snap";

export const Floor_hint = "floor.hint";

export const Floor_noTables = "floor.no_tables";

export const Floor_rotateCcw = "floor.rotate_ccw";

export const Floor_rotateCcwTitle = "floor.rotate_ccw_title";

export const Floor_rotateCw = "floor.rotate_cw";

export const Floor_rotateCwTitle = "floor.rotate_cw_title";

export const Floor_title = "floor.title";

export const Guests_add = "guests.add";

export const Guests_adding = "guests.adding";

export const Guests_age = "guests.age";

export const Guests_ageColumn = "guests.age_column";

export const Guests_cardView = "guests.card_view";

export function Guests_deleteConfirm(v0, v1) {
    return ["guests.delete_confirm", ofArray([v0, v1])];
}

export const Guests_deleteConfirmMsg = "guests.delete_confirm_msg";

export const Guests_deleteGuest = "guests.delete_guest";

export const Guests_dietary = "guests.dietary";

export const Guests_dietaryOther = "guests.dietary_other";

export const Guests_dietaryTags = "guests.dietary_tags";

export const Guests_dietaryTagsHint = "guests.dietary_tags_hint";

export const Guests_editTitle = "guests.edit_title";

export const Guests_familyColumn = "guests.family_column";

export const Guests_firstName = "guests.first_name";

export const Guests_firstNamePlaceholder = "guests.first_name_placeholder";

export const Guests_fullName = "guests.full_name";

export const Guests_fullNamePlaceholder = "guests.full_name_placeholder";

export const Guests_gender = "guests.gender";

export const Guests_genderColumn = "guests.gender_column";

export function Guests_guestNOf(v0, v1) {
    return ["guests.guest_n_of", ofArray([v0, v1])];
}

export function Guests_guestOf(v0) {
    return ["guests.guest_of", singleton(v0)];
}

export const Guests_import = "guests.import";

export function Guests_imported(v0) {
    return ["guests.imported", singleton(v0)];
}

export const Guests_lastName = "guests.last_name";

export const Guests_lastNamePlaceholder = "guests.last_name_placeholder";

export const Guests_nameColumn = "guests.name_column";

export const Guests_networkMap = "guests.network_map";

export const Guests_newTitle = "guests.new_title";

export const Guests_none = "guests.none";

export const Guests_notes = "guests.notes";

export function Guests_plusNFlash(v0, v1) {
    return ["guests.plus_n_flash", ofArray([v0, v1])];
}

export function Guests_plusNGuests(v0) {
    return ["guests.plus_n_guests", singleton(v0)];
}

export function Guests_plusNGuestsPlural(v0) {
    return ["guests.plus_n_guests_plural", singleton(v0)];
}

export const Guests_quickAddPlaceholder = "guests.quick_add_placeholder";

export const Guests_rank = "guests.rank";

export const Guests_rankPlaceholder = "guests.rank_placeholder";

export const Guests_saving = "guests.saving";

export const Guests_search = "guests.search";

export function Guests_seated(v0) {
    return ["guests.seated", singleton(v0)];
}

export function Guests_showing(v0, v1) {
    return ["guests.showing", ofArray([v0, v1])];
}

export const Guests_statusColumn = "guests.status_column";

export const Guests_statusFilter = "guests.statusFilter";

export const Guests_swapNames = "guests.swap_names";

export const Guests_tab = "guests.tab";

export const Guests_tableView = "guests.table_view";

export const Guests_tags = "guests.tags";

export const Guests_tagsColumn = "guests.tags_column";

export const Guests_tagsFilter = "guests.tags_filter";

export const Guests_tagsHint = "guests.tags_hint";

export const Guests_title = "guests.title";

export const Guests_titlePlaceholder = "guests.title_placeholder";

export function Guests_total(v0) {
    return ["guests.total", singleton(v0)];
}

export const Guests_versionConflict = "guests.version_conflict";

export const Guests_voiceInput = "guests.voice_input";

export const Guests_voiceNotSupported = "guests.voice_not_supported";

export const Guests_wheelchair = "guests.wheelchair";

export const Help_chapter01 = "help.chapter_01";

export const Help_chapter02 = "help.chapter_02";

export const Help_chapter03 = "help.chapter_03";

export const Help_chapter04 = "help.chapter_04";

export const Help_chapter05 = "help.chapter_05";

export const Help_chapter06 = "help.chapter_06";

export const Help_chapter07 = "help.chapter_07";

export const Help_chapterIndex = "help.chapter_index";

export const Help_close = "help.close";

export const Help_contactCta = "help.contact_cta";

export const Help_fallbackNotice = "help.fallback_notice";

export const Help_nextChapter = "help.next_chapter";

export const Help_prevChapter = "help.prev_chapter";

export const Help_title = "help.title";

export const Import_back = "import.back";

export const Import_bulkTagsLabel = "import.bulk_tags_label";

export const Import_bulkTagsPlaceholder = "import.bulk_tags_placeholder";

export const Import_cancel = "import.cancel";

export const Import_chooseFile = "import.choose_file";

export const Import_cloneButton = "import.clone_button";

export const Import_cloneDivider = "import.clone_divider";

export function Import_cloneGuestsCount(v0) {
    return ["import.clone_guests_count", singleton(v0)];
}

export const Import_cloneIncludeRelationships = "import.clone_include_relationships";

export const Import_cloneNoEvents = "import.clone_no_events";

export const Import_cloneSelectEvent = "import.clone_select_event";

export const Import_cloning = "import.cloning";

export const Import_close = "import.close";

export function Import_detectedColumns(v0, v1) {
    return ["import.detected_columns", ofArray([v0, v1])];
}

export function Import_detectedGuests(v0) {
    return ["import.detected_guests", singleton(v0)];
}

export const Import_genderUnspecified = "import.gender_unspecified";

export const Import_importButton = "import.import_button";

export const Import_importing = "import.importing";

export const Import_mappingRequired = "import.mapping_required";

export const Import_next = "import.next";

export const Import_noFile = "import.no_file";

export const Import_pasteDivider = "import.paste_divider";

export const Import_pastePlaceholder = "import.paste_placeholder";

export function Import_previewPaste(v0, v1) {
    return ["import.preview_paste", ofArray([v0, v1])];
}

export const Import_previewRows = "import.preview_rows";

export const Import_step1 = "import.step1";

export const Import_step2 = "import.step2";

export const Import_step3 = "import.step3";

export const Import_stepImport = "import.step_import";

export const Import_stepMap = "import.step_map";

export const Import_stepUpload = "import.step_upload";

export const Import_swapNames = "import.swap_names";

export const Import_title = "import.title";

export function Import_totalGuests(v0) {
    return ["import.total_guests", singleton(v0)];
}

export function Import_totalRows(v0) {
    return ["import.total_rows", singleton(v0)];
}

export const Import_unmapped = "import.unmapped";

export const Import_uploadPrompt = "import.upload_prompt";

export const Nav_account = "nav.account";

export const Nav_dashboard = "nav.dashboard";

export const Nav_login = "nav.login";

export const Nav_logout = "nav.logout";

export const Nav_register = "nav.register";

export const Nav_settings = "nav.settings";

export const Overview_rsvp = "overview.rsvp";

export const Progress_acquaintanceSpread = "progress.acquaintance_spread";

export const Progress_ageMixing = "progress.age_mixing";

export const Progress_analyzingRules = "progress.analyzing_rules";

export const Progress_balanceGender = "progress.balance_gender";

export const Progress_balanceTableSizes = "progress.balance_table_sizes";

export const Progress_balancingAssignments = "progress.balancing_assignments";

export const Progress_childNearParent = "progress.child_near_parent";

export const Progress_configuringTables = "progress.configuring_tables";

export const Progress_creatingPresentation = "progress.creating_presentation";

export const Progress_dietaryGrouping = "progress.dietary_grouping";

export const Progress_fillHonorTable = "progress.fill_honor_table";

export const Progress_fineTuning = "progress.fine_tuning";

export const Progress_genderAlternation = "progress.gender_alternation";

export const Progress_guestOfHonor = "progress.guest_of_honor";

export const Progress_hostAtHead = "progress.host_at_head";

export const Progress_loadingGuests = "progress.loading_guests";

export function Progress_processing(v0) {
    return ["progress.processing", singleton(v0)];
}

export const Progress_rankProximity = "progress.rank_proximity";

export const Progress_scoring = "progress.scoring";

export const Progress_separateCouples = "progress.separate_couples";

export const Progress_spreadFamilies = "progress.spread_families";

export const Progress_verifyingRules = "progress.verifying_rules";

export const Progress_wheelchairAccess = "progress.wheelchair_access";

export const Rel_addFamily = "rel.add_family";

export const Rel_addGroup = "rel.add_group";

export const Rel_addPair = "rel.add_pair";

export const Rel_colleagues = "rel.colleagues";

export const Rel_conflict = "rel.conflict";

export const Rel_couple = "rel.couple";

export const Rel_delete = "rel.delete";

export const Rel_deleteConfirm = "rel.delete_confirm";

export const Rel_families = "rel.families";

export const Rel_familyName = "rel.family_name";

export const Rel_familyNamePlaceholder = "rel.family_name_placeholder";

export const Rel_friends = "rel.friends";

export const Rel_groupName = "rel.group_name";

export const Rel_groupNamePlaceholder = "rel.group_name_placeholder";

export const Rel_groupType = "rel.group_type";

export const Rel_groupTypePlaceholder = "rel.group_type_placeholder";

export const Rel_groups = "rel.groups";

export const Rel_guest1 = "rel.guest1";

export const Rel_guest2 = "rel.guest2";

export const Rel_members = "rel.members";

export const Rel_noFamilies = "rel.no_families";

export const Rel_noGroups = "rel.no_groups";

export const Rel_noPairs = "rel.no_pairs";

export const Rel_pairType = "rel.pair_type";

export const Rel_pairs = "rel.pairs";

export const Rel_save = "rel.save";

export const Rel_selectGuest = "rel.select_guest";

export const Rsvp_attendingLabel = "rsvp.attending_label";

export const Rsvp_attendingMaybe = "rsvp.attending_maybe";

export const Rsvp_attendingNo = "rsvp.attending_no";

export const Rsvp_attendingYes = "rsvp.attending_yes";

export const Rsvp_closedMessage = "rsvp.closed_message";

export const Rsvp_closedTitle = "rsvp.closed_title";

export const Rsvp_dietaryLabel = "rsvp.dietary_label";

export const Rsvp_dietaryPlaceholder = "rsvp.dietary_placeholder";

export const Rsvp_errorGeneric = "rsvp.error_generic";

export const Rsvp_errorNetwork = "rsvp.error_network";

export const Rsvp_footer = "rsvp.footer";

export function Rsvp_greeting(v0) {
    return ["rsvp.greeting", singleton(v0)];
}

export const Rsvp_lookupButton = "rsvp.lookup_button";

export const Rsvp_lookupNameRequired = "rsvp.lookup_name_required";

export const Rsvp_lookupNetworkError = "rsvp.lookup_network_error";

export const Rsvp_lookupNotFound = "rsvp.lookup_not_found";

export const Rsvp_lookupPlaceholder = "rsvp.lookup_placeholder";

export const Rsvp_lookupPrompt = "rsvp.lookup_prompt";

export const Rsvp_mealLabel = "rsvp.meal_label";

export const Rsvp_messageLabel = "rsvp.message_label";

export const Rsvp_messagePlaceholder = "rsvp.message_placeholder";

export const Rsvp_notfoundContact = "rsvp.notfound_contact";

export const Rsvp_notfoundMessage = "rsvp.notfound_message";

export const Rsvp_notfoundTitle = "rsvp.notfound_title";

export function Rsvp_pageTitle(v0) {
    return ["rsvp.page_title", singleton(v0)];
}

export const Rsvp_poweredBy = "rsvp.powered_by";

export function Rsvp_respondBy(v0) {
    return ["rsvp.respond_by", singleton(v0)];
}

export const Rsvp_submitButton = "rsvp.submit_button";

export const Rsvp_submitSending = "rsvp.submit_sending";

export const Rsvp_successMessage = "rsvp.success_message";

export function Rsvp_successTitle(v0) {
    return ["rsvp.success_title", singleton(v0)];
}

export const Rsvp_successUpdateAnytime = "rsvp.success_update_anytime";

export function Rsvp_successUpdateBefore(v0) {
    return ["rsvp.success_update_before", singleton(v0)];
}

export const Rsvp_dash_acceptRsvps = "rsvp_dash.accept_rsvps";

export const Rsvp_dash_accepted = "rsvp_dash.accepted";

export const Rsvp_dash_allowPlusOne = "rsvp_dash.allow_plus_one";

export const Rsvp_dash_allowed = "rsvp_dash.allowed";

export const Rsvp_dash_cancel = "rsvp_dash.cancel";

export const Rsvp_dash_close = "rsvp_dash.close";

export const Rsvp_dash_confirmationMessage = "rsvp_dash.confirmation_message";

export const Rsvp_dash_confirmationPlaceholder = "rsvp_dash.confirmation_placeholder";

export const Rsvp_dash_copy = "rsvp_dash.copy";

export const Rsvp_dash_copyAllLinks = "rsvp_dash.copy_all_links";

export const Rsvp_dash_deadline = "rsvp_dash.deadline";

export const Rsvp_dash_deadlineLabel = "rsvp_dash.deadline_label";

export const Rsvp_dash_declined = "rsvp_dash.declined";

export const Rsvp_dash_editSettings = "rsvp_dash.edit_settings";

export const Rsvp_dash_experimentalDesc = "rsvp_dash.experimental_desc";

export const Rsvp_dash_experimentalTitle = "rsvp_dash.experimental_title";

export const Rsvp_dash_generateLinks = "rsvp_dash.generate_links";

export const Rsvp_dash_guest = "rsvp_dash.guest";

export const Rsvp_dash_guestLinks = "rsvp_dash.guest_links";

export const Rsvp_dash_link = "rsvp_dash.link";

export const Rsvp_dash_management = "rsvp_dash.management";

export const Rsvp_dash_maybe = "rsvp_dash.maybe";

export const Rsvp_dash_mealOptions = "rsvp_dash.meal_options";

export const Rsvp_dash_mealPlaceholder = "rsvp_dash.meal_placeholder";

export const Rsvp_dash_mealPreferences = "rsvp_dash.meal_preferences";

export const Rsvp_dash_noGuests = "rsvp_dash.no_guests";

export const Rsvp_dash_notAllowed = "rsvp_dash.not_allowed";

export const Rsvp_dash_notConfigured = "rsvp_dash.not_configured";

export const Rsvp_dash_notGenerated = "rsvp_dash.not_generated";

export const Rsvp_dash_notSent = "rsvp_dash.not_sent";

export const Rsvp_dash_pending = "rsvp_dash.pending";

export const Rsvp_dash_plusOneLabel = "rsvp_dash.plus_one_label";

export const Rsvp_dash_save = "rsvp_dash.save";

export const Rsvp_dash_settings = "rsvp_dash.settings";

export const Rsvp_dash_status = "rsvp_dash.status";

export const Rsvp_dash_statusClosed = "rsvp_dash.status_closed";

export const Rsvp_dash_statusLabel = "rsvp_dash.status_label";

export const Rsvp_dash_statusOpen = "rsvp_dash.status_open";

export const Rsvp_dash_total = "rsvp_dash.total";

export const Rules_add = "rules.add";

export const Rules_ageMix = "rules.age_mix";

export const Rules_couplesTogether = "rules.couples_together";

export const Rules_custom = "rules.custom";

export const Rules_description = "rules.description";

export const Rules_descriptionPlaceholder = "rules.description_placeholder";

export const Rules_familiesTogether = "rules.families_together";

export const Rules_genderBalance = "rules.gender_balance";

export const Rules_hard = "rules.hard";

export const Rules_hardLabel = "rules.hard_label";

export const Rules_hideAdvanced = "rules.hide_advanced";

export const Rules_hosts = "rules.hosts";

export const Rules_hostsPlaceholder = "rules.hosts_placeholder";

export const Rules_newRule = "rules.new_rule";

export const Rules_noConflicts = "rules.no_conflicts";

export const Rules_noRules = "rules.no_rules";

export const Rules_object = "rules.object";

export const Rules_parameter = "rules.parameter";

export const Rules_preset = "rules.preset";

export const Rules_ruleType = "rules.rule_type";

export const Rules_selectGuest = "rules.select_guest";

export const Rules_selectTable = "rules.select_table";

export const Rules_selectTarget = "rules.select_target";

export const Rules_showAdvanced = "rules.show_advanced";

export const Rules_soft = "rules.soft";

export const Rules_softConstraints = "rules.soft_constraints";

export const Rules_subject = "rules.subject";

export const Rules_tab = "rules.tab";

export const Rules_weight = "rules.weight";

export const Rules_weightOff = "rules.weight_off";

export const Sharing_active = "sharing.active";

export const Sharing_copy = "sharing.copy";

export const Sharing_copyEmbedCode = "sharing.copy_embed_code";

export const Sharing_createFindSeat = "sharing.create_find_seat";

export const Sharing_delete = "sharing.delete";

export const Sharing_description = "sharing.description";

export const Sharing_displayLabel = "sharing.display_label";

export const Sharing_embedCode = "sharing.embed_code";

export const Sharing_embedDescription = "sharing.embed_description";

export const Sharing_expiresLabel = "sharing.expires_label";

export const Sharing_findYourSeat = "sharing.find_your_seat";

export const Sharing_floorPlan = "sharing.floor_plan";

export const Sharing_fullChart = "sharing.full_chart";

export const Sharing_goToArrangements = "sharing.go_to_arrangements";

export const Sharing_inactive = "sharing.inactive";

export const Sharing_loading = "sharing.loading";

export function Sharing_lookups(v0) {
    return ["sharing.lookups", singleton(v0)];
}

export const Sharing_nameAndKeyword = "sharing.name_and_keyword";

export const Sharing_nameLookup = "sharing.name_lookup";

export const Sharing_needArrangement = "sharing.need_arrangement";

export const Sharing_noLinks = "sharing.no_links";

export const Sharing_openView = "sharing.open_view";

export const Sharing_pinProtected = "sharing.pin_protected";

export const Sharing_seatingChart = "sharing.seating_chart";

export const Sharing_securityLabel = "sharing.security_label";

export const Sharing_shareFloorPlan = "sharing.share_floor_plan";

export const Sharing_tableAndDiagram = "sharing.table_and_diagram";

export const Sharing_tableAndNeighbors = "sharing.table_and_neighbors";

export const Sharing_tableOnly = "sharing.table_only";

export const Sharing_title = "sharing.title";

export function Sharing_usingArrangement(v0) {
    return ["sharing.using_arrangement", singleton(v0)];
}

export const Solution_compare = "solution.compare";

export const Solution_edit = "solution.edit";

export const Solution_lock = "solution.lock";

export const Solution_none = "solution.none";

export const Solution_reSolve = "solution.re_solve";

export const Solution_redo = "solution.redo";

export const Solution_reset = "solution.reset";

export const Solution_saveAs = "solution.save_as";

export const Solution_select = "solution.select";

export const Solution_undo = "solution.undo";

export const Solution_unlock = "solution.unlock";

export const Solution_view = "solution.view";

export const Solver_cancel = "solver.cancel";

export function Solver_done(v0) {
    return ["solver.done", singleton(v0)];
}

export function Solver_elapsed(v0) {
    return ["solver.elapsed", singleton(v0)];
}

export function Solver_found(v0, v1) {
    return ["solver.found", ofArray([v0, v1])];
}

export const Solver_generate = "solver.generate";

export const Solver_noSolution = "solver.no_solution";

export const Solver_running = "solver.running";

export function Solver_score(v0, v1) {
    return ["solver.score", ofArray([v0, v1])];
}

export function Solver_timeout(v0) {
    return ["solver.timeout", singleton(v0)];
}

export const Step_arrangements = "step.arrangements";

export const Step_cards = "step.cards";

export const Step_guests = "step.guests";

export const Step_rsvp = "step.rsvp";

export const Step_rules = "step.rules";

export const Step_tables = "step.tables";

export const Tab_arrangements = "tab.arrangements";

export const Tab_export = "tab.export";

export const Tab_floorPlan = "tab.floor_plan";

export const Tab_guests = "tab.guests";

export const Tab_rules = "tab.rules";

export const Tab_tables = "tab.tables";

export const Tables_add = "tables.add";

export const Tables_capacity = "tables.capacity";

export const Tables_countLabel = "tables.count_label";

export function Tables_deleteConfirm(v0) {
    return ["tables.delete_confirm", singleton(v0)];
}

export const Tables_editTable = "tables.edit_table";

export const Tables_honor = "tables.honor";

export const Tables_honorCheckbox = "tables.honor_checkbox";

export const Tables_name = "tables.name";

export const Tables_namePlaceholder = "tables.name_placeholder";

export const Tables_newTable = "tables.new_table";

export const Tables_noTables = "tables.no_tables";

export const Tables_oval = "tables.oval";

export const Tables_rectangular = "tables.rectangular";

export const Tables_round = "tables.round";

export function Tables_seatDeficit(v0) {
    return ["tables.seat_deficit", singleton(v0)];
}

export function Tables_seatSurplus(v0) {
    return ["tables.seat_surplus", singleton(v0)];
}

export const Tables_seating = "tables.seating";

export const Tables_seats = "tables.seats";

export const Tables_seatsHead = "tables.seats_head";

export const Tables_seatsLongSide = "tables.seats_long_side";

export const Tables_shape = "tables.shape";

export function Tables_summary(v0, v1, v2) {
    return ["tables.summary", ofArray([v0, v1, v2])];
}

export function Tables_summaryEmpty(v0) {
    return ["tables.summary_empty", singleton(v0)];
}

export function Tables_summaryShort(v0) {
    return ["tables.summary_short", singleton(v0)];
}

export const Tables_tab = "tables.tab";

export const Tables_totalComputed = "tables.total_computed";

export function Tables_totalSeats(v0) {
    return ["tables.total_seats", singleton(v0)];
}

export const Tables_warningSeatsShort = "tables.warning_seats_short";

export const Tag_groups_bridge = "tag_groups.bridge";

export function Tag_groups_bridgeDesc(v0, v1) {
    return ["tag_groups.bridge_desc", ofArray([v0, v1])];
}

export const Tag_groups_cluster = "tag_groups.cluster";

export function Tag_groups_clusterDesc(v0, v1) {
    return ["tag_groups.cluster_desc", ofArray([v0, v1])];
}

export const Tag_groups_custom1 = "tag_groups.custom1";

export const Tag_groups_custom2 = "tag_groups.custom2";

export const Tag_groups_education = "tag_groups.education";

export const Tag_groups_groupLabel = "tag_groups.group_label";

export const Tag_groups_hobby = "tag_groups.hobby";

export const Tag_groups_ignore = "tag_groups.ignore";

export function Tag_groups_ignoreDesc(v0, v1) {
    return ["tag_groups.ignore_desc", ofArray([v0, v1])];
}

export const Tag_groups_language = "tag_groups.language";

export const Tag_groups_lifeStage = "tag_groups.life_stage";

export const Tag_groups_organizational = "tag_groups.organizational";

export const Tag_groups_pair = "tag_groups.pair";

export function Tag_groups_pairDesc(v0, v1) {
    return ["tag_groups.pair_desc", ofArray([v0, v1])];
}

export const Tag_groups_spread = "tag_groups.spread";

export function Tag_groups_spreadDesc(v0, v1) {
    return ["tag_groups.spread_desc", ofArray([v0, v1])];
}

export const Tag_groups_strategy = "tag_groups.strategy";

export const Tag_groups_title = "tag_groups.title";

export const Tags_delete = "tags.delete";

export function Tags_guestsCount(v0) {
    return ["tags.guests_count", singleton(v0)];
}

export const Tags_merge = "tags.merge";

export const Tags_mergeHint = "tags.merge_hint";

export const Tags_noTags = "tags.no_tags";

export const Tags_noTagsMessage = "tags.no_tags_message";

export const Tags_rename = "tags.rename";

export const Tags_title = "tags.title";

export const Toast_arrangementLiked = "toast.arrangementLiked";

export const Toast_arrangementSelected = "toast.arrangementSelected";

export const Toast_arrangementUnliked = "toast.arrangementUnliked";

export const Toast_error = "toast.error";

export const Toast_familyCreated = "toast.familyCreated";

export const Toast_familyDeleted = "toast.familyDeleted";

export const Toast_feedbackSaved = "toast.feedbackSaved";

export const Toast_groupCreated = "toast.groupCreated";

export const Toast_groupDeleted = "toast.groupDeleted";

export const Toast_guestCreated = "toast.guestCreated";

export const Toast_guestDeleted = "toast.guestDeleted";

export const Toast_guestUpdated = "toast.guestUpdated";

export const Toast_importCompleted = "toast.importCompleted";

export const Toast_pairCreated = "toast.pairCreated";

export const Toast_pairDeleted = "toast.pairDeleted";

export const Toast_ruleCreated = "toast.ruleCreated";

export const Toast_ruleDeleted = "toast.ruleDeleted";

export const Toast_seatLocked = "toast.seatLocked";

export const Toast_seatUnlocked = "toast.seatUnlocked";

export const Toast_tableCreated = "toast.tableCreated";

export const Toast_tableDeleted = "toast.tableDeleted";

export const Toast_tableUpdated = "toast.tableUpdated";

export const Toast_weightsSaved = "toast.weightsSaved";

export const Tooltip_culturePreset = "tooltip.culturePreset";

export const Tooltip_editMode = "tooltip.editMode";

export const Tooltip_emptySeatStrategy = "tooltip.emptySeatStrategy";

export const Tooltip_lockFeature = "tooltip.lockFeature";

export const Tooltip_relationships = "tooltip.relationships";

export const Tooltip_scoreBadge = "tooltip.scoreBadge";

export const Tooltip_violations = "tooltip.violations";

export const Tooltip_weightSlider = "tooltip.weightSlider";

export const Weight_AcquaintanceSpread = "weight.AcquaintanceSpread";

export const Weight_AgeMixing = "weight.AgeMixing";

export const Weight_BalanceGender = "weight.BalanceGender";

export const Weight_BalanceTableSizes = "weight.BalanceTableSizes";

export const Weight_ChildNearParent = "weight.ChildNearParent";

export const Weight_FillHonorTable = "weight.FillHonorTable";

export const Weight_GenderAlternation = "weight.GenderAlternation";

export const Weight_GuestOfHonor = "weight.GuestOfHonor";

export const Weight_HostAtHead = "weight.HostAtHead";

export const Weight_RankProximity = "weight.RankProximity";

export const Weight_SeparateCouples = "weight.SeparateCouples";

export const Weight_SpreadFamilies = "weight.SpreadFamilies";

export const Weight_TagGroupSeating = "weight.TagGroupSeating";

export const Weight_WheelchairAccess = "weight.WheelchairAccess";

